import React, {useState} from 'react';
import purify from 'dompurify';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import VeilederRenterDto from '../Models/VeilederRenterDto';

interface Props {
    side: VeilederRenterDto;
}

export default function BoksB(props: Props): JSX.Element {
    
    const [visModal, setVisModal] = useState(false);

    function onModalClick(): void {
        setVisModal(true);
    }

    function onRequestLukkModal(): void {
        setVisModal(false);
    }

    function hentFastrenter(): JSX.Element | null {
        if(!props.side.fastRente3 || !props.side.fastRente5 || !props.side.fastRente10) {
            return null;
        }

        return (
            <div className="c-veileder--enkel-tekst-kontainer">
                <div className="c-veileder--enkel-tekst">{props.side.fastRente3}</div>
                <div className="c-veileder--enkel-tekst">{props.side.fastRente5}</div>
                <div className="c-veileder--enkel-tekst">{props.side.fastRente10}</div>
            </div>
        )
    }

    function hentKnapp(): JSX.Element | null {     
        if(!props.side.knappetekst) return null;                
        
        if(props.side.knappStil === "Primary")
            return <a className="c-knapp c-knapp--cta c-knapp--primary" href={props.side.knappUrl}>{props.side.knappetekst}</a>

        if(props.side.knappStil === "Secondary")
            return <a className="c-knapp c-knapp--cta c-knapp--secondary" href={props.side.knappUrl}>{props.side.knappetekst}</a>

        if(props.side.knappStil === "Lenke")
            return <div className="c-veileder-lenke-kontainer"><a className="c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-aubergine" href={props.side.knappUrl}>{props.side.knappetekst}</a></div>
            
        return <a className="c-knapp c-knapp--cta c-knapp--primary" href={props.side.knappUrl}>{props.side.knappetekst}</a>        
    }

    return (
        <div className="c-veileder__panel c-veileder__panel--lilac">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <h3 className="c-veileder--overskrift c-veileder--overskrift-stor">
                        {props.side.overskriftBoksB}
                    </h3>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <div className="c-veileder__content--textarea">
                        <div className="c-veileder--tekstomraade"  dangerouslySetInnerHTML={{ __html: purify.sanitize(props.side.tekstBoksB?.value) }} />
                        <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onModalClick}>
                            {props.side.modalFastRenteLenketekst}
                        </button>
                        <ModalCompontent
                            isOpen={visModal}
                            onRequestClose={onRequestLukkModal}
                            ariaCloseText={props.side.modalFastRenteLukkTekst}
                        >
                            <ArticleContentComponent
                                headerinnhold={<span>{props.side.modalFastRenteTittel}</span>}
                                contentinnhold={<div dangerouslySetInnerHTML={{ __html: purify.sanitize(props.side.modalFastRenteTekst?.value)}} />}
                            />
                        </ModalCompontent>
                    </div>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <h4 className="c-veileder__undersporsmal">{props.side.overskriftFastRente}</h4>
                    {hentFastrenter()}
                    <div className="c-veileder--tekstomraade">{props.side.fastRenteStottetekst}</div>
                    {hentKnapp()}
                </div>
            </div>
        </div>
    )
}
